import { render, staticRenderFns } from "./ModelIcon.vue?vue&type=template&id=607fd40e"
import script from "./ModelIcon.vue?vue&type=script&lang=ts"
export * from "./ModelIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports